module.exports = __webpack_public_path__ + "img/fruti-di-mare.fb6e2dda.png";